import { render, staticRenderFns } from "./integral-bills.vue?vue&type=template&id=04037339&scoped=true&"
import script from "./integral-bills.vue?vue&type=script&lang=js&"
export * from "./integral-bills.vue?vue&type=script&lang=js&"
import style0 from "./integral-bills.vue?vue&type=style&index=0&id=04037339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04037339",
  null
  
)

export default component.exports